import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid, Hidden as BaseHidden } from '@material-ui/core'
import { InputPrefix } from '@chilecompra/react-kit/components'

export const Root = styled.div`
  margin: 0;
  padding: 0 0 130px;
  width: 100%;
`

export const Announcement = styled.div`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 13px;
  font-weight: 300;
  line-height: 18px;
  margin-top: 15px;
`

export const ClaveUnicaImage = styled.img`
  height: 20px;
`

export const Column = styled(BaseGrid)``

export const Conditions = styled.div`
  margin-top: 25px;
  font-size: 13px;
  line-height: 18px;
  font-weight: 300;
`

export const Form = styled.form`
  margin-top: 15px;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};
  padding: ${props => props.padding || '0'};
  text-align: left;
`

export const Image = styled.img`
  width: 100%;
  ${props => props.theme.breakpoints.down('xs')} {
    max-width: 140px;
    display: block;
    margin: 0 auto;
  }
`

export const Information = styled.div`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 7px;
`

export const LoginLink = styled.a``

export const MessageError = styled.p``

export const Instructions = styled.section`
  font-size: 22px;
  font-weight: 300;
  line-height: 26px;
  margin-top: 28px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const Title = styled.h1`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  line-height: 45px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const PhoneNumberPrefix = styled(InputPrefix)`
  padding: 0.375rem 0.75rem;
`

export const Hidden = styled(BaseHidden)``

export const DesktopNavigation = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0;
  width: 100%;
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`
